import React from "react";
import {Box, Button, Dialog, DialogActions, DialogContent, IconButton, Tooltip} from "@mui/material";
import Login from "../Login/Login";
import Register from "../Register/Register";
import {useTranslation} from "react-i18next";
import CallMadeIcon from "@mui/icons-material/CallMade";
import {useHistory} from "react-router-dom";


export default function PortalDialog(props) {
    const {t} = useTranslation('common');
    const history = useHistory();
    const [content, setContent] = React.useState("login");

    const goToPortal = () => {
        history.push(`/portal?selected=${content}`);
    }

    return (
        <Dialog {...props}>
            <DialogContent>
                <Box display="flex" flexDirection="row-reverse">
                    <Tooltip title={t("main.components.auth.gotoportal")} arrow>
                        <IconButton onClick={goToPortal}>
                            <CallMadeIcon fontSize="small"/>
                        </IconButton>
                    </Tooltip>
                </Box>
                {content === "login"
                    ? <Login
                        onClickRegister={() => setContent("register")}
                        onSuccess={props.onClose}
                    />
                    : <Register onClickLogin={() => setContent("login")}/>
                }
            </DialogContent>
            {props.onClose && <DialogActions>
                <Button onClick={props.onClose} color="secondary">{t("main.components.button.cancel")}</Button>
            </DialogActions>}
        </Dialog>
    );
}
